import { render, staticRenderFns } from "./APIAccessKeys.vue?vue&type=template&id=a794d6c0&scoped=true"
import script from "./APIAccessKeys.vue?vue&type=script&lang=js"
export * from "./APIAccessKeys.vue?vue&type=script&lang=js"
import style0 from "./APIAccessKeys.vue?vue&type=style&index=0&id=a794d6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a794d6c0",
  null
  
)

export default component.exports